export const POWER_BALANCE_CHANGED_EVENT = "gunziai:power-balance-changed";

const POWER_BALANCE_CHANNEL_NAME = "gunziai-power-balance";

export type PowerBalanceChangedDetail = {
    source?: string;
    at: number;
};

type PowerBalanceChangedListener = (detail: PowerBalanceChangedDetail) => void;

let broadcastChannel: BroadcastChannel | undefined;

function getBroadcastChannel() {
    if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") {
        return undefined;
    }

    broadcastChannel ??= new BroadcastChannel(POWER_BALANCE_CHANNEL_NAME);
    return broadcastChannel;
}

function dispatchLocal(detail: PowerBalanceChangedDetail) {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new CustomEvent(POWER_BALANCE_CHANGED_EVENT, { detail }));
}

export function notifyPowerBalanceChanged(source?: string) {
    const detail: PowerBalanceChangedDetail = {
        source,
        at: Date.now(),
    };

    dispatchLocal(detail);
    getBroadcastChannel()?.postMessage(detail);
}

export function subscribePowerBalanceChanged(listener: PowerBalanceChangedListener) {
    if (typeof window === "undefined") {
        return () => {};
    }

    const onWindowEvent = (event: Event) => {
        listener((event as CustomEvent<PowerBalanceChangedDetail>).detail);
    };

    const channel = getBroadcastChannel();
    const onChannelMessage = (event: MessageEvent<PowerBalanceChangedDetail>) =>
        listener(event.data);

    window.addEventListener(POWER_BALANCE_CHANGED_EVENT, onWindowEvent);
    channel?.addEventListener("message", onChannelMessage);

    return () => {
        window.removeEventListener(POWER_BALANCE_CHANGED_EVENT, onWindowEvent);
        channel?.removeEventListener("message", onChannelMessage);
    };
}
